import { Box, IconButton, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import pxToRem from "theme/base/pxToRem";
import { ReactComponent as IconCalendar } from "assets/svg/20-calendar.svg";

import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";

const locale = "vi";

interface CustomCalendarProps {
  label: string;
  value: moment.Moment;
  maxDate?: moment.Moment | null;
  minDate?: moment.Moment | null;
  onChange: (newValue: moment.Moment) => void;
  format?: string;
}

export const CustomCalendar = ({
  label,
  value,
  maxDate = null,
  minDate = null,
  format = "MM/YYYY",
  onChange,
}: CustomCalendarProps) => {
  return (
    <>
      <Box display={"flex"} alignItems={"center"}>
        <Box display={"flex"} alignItems={"center"}>
          <Typography
            fontSize={14}
            fontWeight={400}
            display={"flex"}
            gap={1}
            alignItems={"center"}
          >
            <Typography
              sx={(theme) => ({
                fontSize: theme.typography.size.sm_14,
                color: theme.palette.text.textTertiary,
              })}
            >
              {label}
            </Typography>
            {value.format(format)}
          </Typography>
          <LocalizationProvider
            dateAdapter={AdapterMoment}
            adapterLocale={locale}
          >
            <DatePicker
              views={["month", "year"]}
              sx={{
                fieldset: {
                  border: "none",
                },
                ".MuiInputBase-root.MuiOutlinedInput-root": {
                  paddingRight: pxToRem(4),
                  input: {
                    paddingLeft: pxToRem(4),
                    display: "none",
                  },
                },
                ".MuiInputAdornment-root.MuiInputAdornment-positionEnd": {
                  opacity: 0,
                  position: "absolute",
                  right: pxToRem(50),
                  button: {
                    width: pxToRem(120),
                    marginRight: `-${pxToRem(75)}`,
                  },
                },
              }}
              value={value}
              format={format}
              onChange={(newValue) => {
                onChange(newValue);
              }}
              maxDate={maxDate}
              minDate={minDate}
            />
          </LocalizationProvider>
        </Box>
        <IconButton
          sx={(theme) => ({
            svg: {
              width: pxToRem(20),
              height: pxToRem(20),
              path: { fill: theme.palette.icon.icDefault },
            },
            pointerEvents: "none",
          })}
        >
          <IconCalendar />
        </IconButton>
      </Box>
    </>
  );
};
